import styles from './EmpSchedule.module.css'
import React from 'react';
import '../assets/css/main.css';
import '../assets/css/nice-select2.css';
import '../assets/css/swiper-bundle.min.css';
import {Notice, initForms, initLayoutScripts} from '../assets/js/notice.js'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export default class EmpSchedule extends React.Component {
    constructor(props) {
        super(props);

        this.state = { lname: props.lname, fname: props.fname, sname: props.sname, email: props.email, tel: props.tel, emp_id: props.emp_id, UID: props.UID, profile: props.profile,
                       loading: false, partial_loading: [], error_messages: props.error_messages, update_error_messages_callback: props.update_error_messages_callback, schedule: {},
                       business_units_uids: [], index: 0, display: 3, loaded: [], max: 9, is_mobile: false};

        //Если пользователь авторизован как клиент, меняем страницу на главную
        if(localStorage.getItem('accessToken'))
            window.location = "/";

        //Если пользователь не авторизован, перенаправляем его на страницу входа
        if(!localStorage.getItem('empAccessToken'))
            window.location = "/emplogin";

        this.swiperRef = React.createRef();
        this.partial_loading_cache = [];
    }

    componentDidUpdate(prevProps) {
        //Если есть ошибки, выводим всплывающее окно с ними
        if(this.state.error_messages.length > 0)
            Notice.show(this.state.error_messages.join('<br/>'));

        if(prevProps.lname !== this.props.lname)
            this.setState({lname: this.props.lname});
        if(prevProps.fname !== this.props.fname)
            this.setState({fname: this.props.fname});
        if(prevProps.sname !== this.props.sname)
            this.setState({sname: this.props.sname});
        if(prevProps.email !== this.props.email)
            this.setState({email: this.props.email});
        if(prevProps.tel !== this.props.tel)
            this.setState({tel: this.props.tel});
        if(prevProps.emp_id !== this.props.emp_id)
            this.setState({emp_id: this.props.emp_id});
        if(prevProps.UID !== this.props.UID)
            this.setState({UID: this.props.UID});
        if(prevProps.profile !== this.props.profile)
            this.setState({profile: this.props.profile});
        if(prevProps.error_messages !== this.props.error_messages)
            this.setState({error_messages: this.props.error_messages});
        if(prevProps.update_error_messages_callback !== this.props.update_error_messages_callback)
            this.setState({update_error_messages_callback: this.props.update_error_messages_callback});
    }

    checkViewport = () => {
        const is_mobile = window.innerWidth < 768;
        this.setState({display: is_mobile ? 1 : 3, is_mobile: is_mobile});
    };

    componentDidMount() {
        //Отслеживаем размер экрана
        this.checkViewport();
        window.addEventListener('resize', this.checkViewport);

        //Инициализируем скрипты от верстальщиков
        initLayoutScripts();
        Notice.setHideCallback(() => { this.setState({error_messages: []}); this.state.update_error_messages_callback([]); });

        //Заполняем расписание пустыми днями
        let schedule = this.state.schedule;
        for(let i = 0; i <= this.state.max; i++)
            schedule[new Date(Date.now() + i * 86400000).toISOString().split('T')[0]] = {};
        this.setState({schedule: schedule});

        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Счетчик обработанных запросов
        const requests_to_fetch = 2;
        let requests_processed = 0;

        //Запрашиваем расписание
        fetch('/api/GetEmployeeSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')},
            body: JSON.stringify({ "sdate": new Date().toISOString().slice(0, 10).replace(/-/g, ''), //Текущая дата
                                   "edate": new Date(Date.now() + 3 * 86400000).toISOString().slice(0, 10).replace(/-/g, '') })}) //Сдвиг на несколько дней вперед
            .then(response => response.json())
            .then(data => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false});

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //Проверяем флаг результата
                if(data.result)
                {
                    //Парсим данные
                    let schedule = this.state.schedule;
                    for(let date of Object.entries(data.body))
                    {
                        schedule[date[0]] = {};
                        for(let emp of Object.values(date[1]))
                            for(let emp_internal of Object.entries(emp))
                            {
                                if(emp_internal[0] == "deftime" || emp_internal[0] == "empfio" || emp_internal[0] == "smember")
                                    continue;

                                for(let time of Object.entries(emp_internal[1]))
                                    schedule[date[0]][time[0]] = time[1];
                            }
                    }

                    this.setState({schedule: schedule, loaded: [0, 1, 2, 3]});
                }
                else
                {
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('empAccessToken');
                        window.location = "/emplogin";
                    }
                }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });

        //Запрашиваем соответствия uid - название бизнес-подразделения
        fetch('/api/GetBuList', { method: 'GET', headers: { 'zr-emp-access-token': localStorage.getItem('empAccessToken') } })
            .then(response => response.json())
            .then(data => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false});

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //Парсим данные
                if(data.result)
                    this.setState({ business_units_uids: data.body });
                else
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('empAccessToken');
                        window.location = "/emplogin";
                    }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
    }

    componentWillUnmount() {
        //Перестаём отслеживать размер экрана
        window.removeEventListener('resize', this.checkViewport);
    }

    changeDateFormat = (date) => {
        if(date.length < 10)
            return date;
        let new_date = date[8] + date[9] + '.' + date[5] + date[6] + '.' + date[0] + date[1] + date[2] + date[3] + date.substring(10, date.length);
        return new_date;
    }

    arrowLeft = (e) => {
        //Сдвигаем расписание влево
        if(this.swiperRef)
          this.swiperRef.current.swiper.slidePrev();

        //Сохраняем новый индекс
        let index = this.state.index - 1
        this.setState({index: index});

        //Загружаем следующую порцию при необходимости
        if(!this.state.loaded.includes(index) && !this.partial_loading_cache.includes(index))
        {
            //Включаем анимацию загрузки
            this.partial_loading_cache.push(index);
            this.setState({ partial_loading: this.partial_loading_cache });

            //Запрашиваем расписание
            fetch('/api/GetEmployeeSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')},
                body: JSON.stringify({ "sdate": new Date(Date.now() + index * 86400000).toISOString().slice(0, 10).replace(/-/g, ''), //Текущая дата + кол-во загруженных
                                       "edate": new Date(Date.now() + index * 86400000).toISOString().slice(0, 10).replace(/-/g, '') })}) //Сдвиг на несколько дней вперед
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== index);
                    let loaded = this.state.loaded;
                    loaded.push(index);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                    {
                        //Устанавливаем ошибку и прекращаем обработку
                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                        return;
                    }

                    //Проверяем флаг результата
                    if(data.result)
                    {
                        //Парсим данные
                        let schedule = this.state.schedule;
                        for(let date of Object.entries(data.body))
                        {
                            schedule[date[0]] = {};
                            for(let emp of Object.values(date[1]))
                                for(let emp_internal of Object.entries(emp))
                                {
                                    if(emp_internal[0] == "deftime" || emp_internal[0] == "empfio" || emp_internal[0] == "smember")
                                        continue;

                                    for(let time of Object.entries(emp_internal[1]))
                                        schedule[date[0]][time[0]] = time[1];
                                }
                        }

                        this.setState({schedule: schedule});
                    }
                    else
                    {
                        //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                        if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                        {
                            localStorage.removeItem('empAccessToken');
                            window.location = "/emplogin";
                        }
                    }
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== index);
                    let loaded = this.state.loaded;
                    loaded.push(index);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });
                    //Устанавливаем ошибку
                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                });
        }
    }

    arrowRight = (e) => {
        //Сдвигаем расписание вправо
        if(this.swiperRef)
          this.swiperRef.current.swiper.slideNext();

        //Сохраняем новый индекс
        let index = this.state.index + 1
        this.setState({index: index});

        //Загружаем следующую порцию при необходимости
        if(!this.state.loaded.includes(index + this.state.display - 1) && !this.partial_loading_cache.includes(index + this.state.display - 1))
        {
            //Включаем анимацию загрузки
            this.partial_loading_cache.push(index + this.state.display - 1);
            this.setState({ partial_loading: this.partial_loading_cache });

            //Запрашиваем расписание
            fetch('/api/GetEmployeeSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')},
                body: JSON.stringify({ "sdate": new Date(Date.now() + (index + this.state.display - 1) * 86400000).toISOString().slice(0, 10).replace(/-/g, ''), //Текущая дата + кол-во загруженных
                                       "edate": new Date(Date.now() + (index + this.state.display - 1) * 86400000).toISOString().slice(0, 10).replace(/-/g, '') })}) //Сдвиг на несколько дней вперед
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== (index + this.state.display - 1));
                    let loaded = this.state.loaded;
                    loaded.push(index + this.state.display - 1);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                    {
                        //Устанавливаем ошибку и прекращаем обработку
                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                        return;
                    }

                    //Проверяем флаг результата
                    if(data.result)
                    {
                        //Парсим данные
                        let schedule = this.state.schedule;
                        for(let date of Object.entries(data.body))
                        {
                            schedule[date[0]] = {};
                            for(let emp of Object.values(date[1]))
                                for(let emp_internal of Object.entries(emp))
                                {
                                    if(emp_internal[0] == "deftime" || emp_internal[0] == "empfio" || emp_internal[0] == "smember")
                                        continue;

                                    for(let time of Object.entries(emp_internal[1]))
                                        schedule[date[0]][time[0]] = time[1];
                                }
                        }

                        this.setState({schedule: schedule});
                    }
                    else
                    {
                        //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                        if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                        {
                            localStorage.removeItem('empAccessToken');
                            window.location = "/emplogin";
                        }
                    }
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== (index + this.state.display - 1));
                    let loaded = this.state.loaded;
                    loaded.push(index + this.state.display - 1);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });
                    //Устанавливаем ошибку
                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                });
        }
    }

    handleArbitraryIndexChange = (e) => {
        //Сохраняем новый индекс
        let index = parseInt(e.target.value);
        this.setState({index: index});

        //Сдвигаем расписание к указанному индексу
        if(this.swiperRef)
          this.swiperRef.current.swiper.slideTo(index);

        //Загружаем следующую порцию при необходимости
        if(!this.state.loaded.includes(index) && !this.partial_loading_cache.includes(index))
        {
            //Включаем анимацию загрузки
            this.partial_loading_cache.push(index);
            this.setState({ partial_loading: this.partial_loading_cache });

            //Запрашиваем расписание
            fetch('/api/GetEmployeeSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')},
                body: JSON.stringify({ "sdate": new Date(Date.now() + (index) * 86400000).toISOString().slice(0, 10).replace(/-/g, ''), //Текущая дата + кол-во загруженных
                                       "edate": new Date(Date.now() + (index) * 86400000).toISOString().slice(0, 10).replace(/-/g, '') })}) //Сдвиг на несколько дней вперед
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== index);
                    let loaded = this.state.loaded;
                    loaded.push(index);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                    {
                        //Устанавливаем ошибку и прекращаем обработку
                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                        return;
                    }

                    //Проверяем флаг результата
                    if(data.result)
                    {
                        //Парсим данные
                        let schedule = this.state.schedule;
                        for(let date of Object.entries(data.body))
                        {
                            schedule[date[0]] = {};
                            for(let emp of Object.values(date[1]))
                                for(let emp_internal of Object.entries(emp))
                                {
                                    if(emp_internal[0] == "deftime" || emp_internal[0] == "empfio" || emp_internal[0] == "smember")
                                        continue;

                                    for(let time of Object.entries(emp_internal[1]))
                                        schedule[date[0]][time[0]] = time[1];
                                }
                        }

                        this.setState({schedule: schedule});
                    }
                    else
                    {
                        //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                        if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                        {
                            localStorage.removeItem('empAccessToken');
                            window.location = "/emplogin";
                        }
                    }
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки
                    this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== index);
                    let loaded = this.state.loaded;
                    loaded.push(index);
                    this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });
                    //Устанавливаем ошибку
                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                });
        }
    }

    getBuChangeTimesMultiDay = (multiDaySchedule) => {
        const result = {};

        for (const [date, dailySchedule] of Object.entries(multiDaySchedule)) {
            if (Object.keys(dailySchedule).length === 0) {
                // Пропускаем пустые дни
                continue;
            }

            const dailyChanges = {};
            let prevBuid = null;
            let firstProcessed = false;

            for (const [time, entry] of Object.entries(dailySchedule).sort((a, b) => a[0].localeCompare(b[0]))) {
                const currentBuid = entry.buid;

                if (!firstProcessed) {
                    // Добавляем первую запись дня
                    dailyChanges[time] = currentBuid;
                    prevBuid = currentBuid;
                    firstProcessed = true;
                    continue;
                }

                if (currentBuid !== prevBuid) {
                    // Добавляем запись при изменении buid
                    dailyChanges[time] = currentBuid;
                    prevBuid = currentBuid;
                }
            }

            // Добавляем результат для дня, если были записи
            if (Object.keys(dailyChanges).length > 0) {
                result[date] = dailyChanges;
            }
        }

        return result;
    }

    handleSlideChange = (swiper) => {
        //Сдвигаем расписание к указанному индексу
        let index = swiper.activeIndex;
        this.setState({index: index});

        for(let i = index; i < index + this.state.display; i++)
            //Загружаем следующую порцию при необходимости
            if(!this.state.loaded.includes(i) && !this.partial_loading_cache.includes(i))
            {
                //Включаем анимацию загрузки
                this.partial_loading_cache.push(i);
                this.setState({ partial_loading: this.partial_loading_cache });

                //Запрашиваем расписание
                fetch('/api/GetEmployeeSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')},
                    body: JSON.stringify({ "sdate": new Date(Date.now() + (i) * 86400000).toISOString().slice(0, 10).replace(/-/g, ''), //Текущая дата + кол-во загруженных
                                           "edate": new Date(Date.now() + (i) * 86400000).toISOString().slice(0, 10).replace(/-/g, '') })}) //Сдвиг на несколько дней вперед
                    .then(response => response.json())
                    .then(data => {
                        //Выключаем анимацию загрузки
                        this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== i);
                        let loaded = this.state.loaded;
                        loaded.push(i);
                        this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });

                        //Проверяем наличие обязательных полей в ответе
                        if(!('result' in data) || !('body' in data))
                        {
                            //Устанавливаем ошибку и прекращаем обработку
                            if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                            return;
                        }

                        //Проверяем флаг результата
                        if(data.result)
                        {
                            //Парсим данные
                            let schedule = this.state.schedule;
                            for(let date of Object.entries(data.body))
                            {
                                schedule[date[0]] = {};
                                for(let emp of Object.values(date[1]))
                                    for(let emp_internal of Object.entries(emp))
                                    {
                                        if(emp_internal[0] == "deftime" || emp_internal[0] == "empfio" || emp_internal[0] == "smember")
                                            continue;

                                        for(let time of Object.entries(emp_internal[1]))
                                            schedule[date[0]][time[0]] = time[1];
                                    }
                            }

                            this.setState({schedule: schedule});
                        }
                        else
                        {
                            //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                            if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                            {
                                localStorage.removeItem('empAccessToken');
                                window.location = "/emplogin";
                            }
                        }
                    })
                    .catch((error) => {
                        //Выключаем анимацию загрузки
                        this.partial_loading_cache = this.partial_loading_cache.filter(num => num !== i);
                        let loaded = this.state.loaded;
                        loaded.push(i);
                        this.setState({ partial_loading: this.partial_loading_cache, loaded: loaded });
                        //Устанавливаем ошибку
                        if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                    });
            }
    }

    render() {
        //Получаем изменения подразделений в расписании
        let bu_changes = this.getBuChangeTimesMultiDay(this.state.schedule);

        return (
            <>
                <>
                    {this.state.loading &&
                    <div class="pre-loader">
                        <div class="loader-spinner">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    }
                </>

                <div>
                    <h1>Расписание</h1>
                    <div className={styles.scheduleHorzFlex}>
                        <div className={[styles.scheduleLeftArrow, this.state.index === 0 ? styles.scheduleHidden : ''].join(' ').trim()} onClick={this.arrowLeft}>
                            <svg viewBox="0 0 24 24" width="32" height="32">
                                <path fill="white" d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                            </svg>
                        </div>
                        <Swiper ref={this.swiperRef} spaceBetween={5} slidesPerView={this.state.is_mobile ? 1 : 3} onSlideChange={this.handleSlideChange}>
                            {Object.entries(this.state.schedule).map((dates, index) =>
                                <SwiperSlide key={dates[0]}>
                                    <div className={[styles.scheduleVertFlex, dates[0] === new Date().toISOString().split('T')[0] ? styles.scheduleToday : ''].join(' ').trim()}>
                                        {this.state.is_mobile == true &&
                                        <form>
                                            <select value={this.state.index} onChange={this.handleArbitraryIndexChange} className={styles.scheduleColumnHeader}>
                                                {Array(this.state.max + 1).fill().map((_, index) =>
                                                    <option value={index} key={index}>{this.changeDateFormat(new Date(Date.now() + index * 86400000).toISOString().split('T')[0])} ({new Intl.DateTimeFormat('ru-RU', { weekday: 'short' }).format(new Date(new Date(Date.now() + index * 86400000).toISOString().split('T')[0]))})</option>
                                                )}
                                            </select>
                                        </form>
                                        }
                                        {this.state.is_mobile == false &&
                                        <div className={styles.scheduleColumnHeader}>{this.changeDateFormat(dates[0])} ({new Intl.DateTimeFormat('ru-RU', { weekday: 'short' }).format(new Date(dates[0]))})</div>
                                        }
                                        {this.state.loaded.includes(index) && Object.entries(dates[1]).length !== 0 && Object.entries(dates[1]).sort((a, b) => a[0].localeCompare(b[0])).map((times) =>
                                            <>
                                                {dates[0] in bu_changes && times[0] in bu_changes[dates[0]] && this.state.business_units_uids.filter((data) => data.onec_uid === bu_changes[dates[0]][times[0]]).length != 0 &&
                                                    <div className={styles.buChange}>{this.state.business_units_uids.filter((data) => data.onec_uid === bu_changes[dates[0]][times[0]])[0].bu_name}</div>
                                                }
                                                <div className={[styles.scheduleRow,
                                                    ('status' in times[1] && times[1].status == 1) ? styles.status1 :
                                                        (('status' in times[1] && times[1].status == 2) ? styles.status2 :
                                                        (('status' in times[1] && times[1].status == 3) ? styles.status3 :
                                                            (('status' in times[1] && times[1].status == 4) ? styles.status4 :
                                                                (('status' in times[1] && times[1].status == 10) ? styles.status10 : styles.free))))].join(' ')}>
                                                    <div>{times[1].stime} - {times[1].etime}</div>
                                                    {times[1].type == 1 &&
                                                        <div>Свободно</div>
                                                    }
                                                    {times[1].type != 1 && 'сlname' in times[1] &&
                                                        <div>{times[1].сlname}</div>
                                                    }
                                                    {times[1].type != 1 && 'srvs' in times[1] && times[1].srvs.length > 0 && 'srvname' in times[1].srvs[0] &&
                                                        <div>{times[1].srvs[0].srvname}</div>
                                                    }
                                                </div>
                                            </>
                                        )}
                                        {!this.state.loaded.includes(index) && Object.entries(dates[1]).length === 0 &&
                                            <div class="no-schedule-container"><div class="no-schedule-inner loading-schedule">Расписание загружается</div></div>}
                                        {this.state.loaded.includes(index) && Object.entries(dates[1]).length === 0 &&
                                            <div className={styles.buChange}>Расписание отсутствует</div>
                                        }
                                    </div>
                                </SwiperSlide>
                            )}
                        </Swiper>
                        <div className={[styles.scheduleRightArrow, (this.state.index + this.state.display - 1) >= this.state.max ? styles.scheduleHidden : ''].join(' ').trim()} onClick={this.arrowRight}>
                            <svg viewBox="0 0 24 24" width="32" height="32">
                                <path fill="white" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
